import React, { Component } from 'react'
import Styled from 'styled-components'
import { connect } from 'react-redux'

import {
  createThemeState,
  destroyThemeState
} from 'actions/theme'

import { Prompt } from 'router/index'

import ComponentRenderer from 'components/ComponentRenderer'
import PageComponent from 'components/PageComponent'
import EditorCanvas from 'components/EditorCanvas'
import Viewport from 'components/Viewport'
import ThemeEditor from 'components/ThemeEditor'

const Main = Styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
`

const Page = Styled.div`
  background-color: #fff;
  box-shadow: 0 0.25rem 1rem 0 rgba(51, 51, 51, 0.1);
  margin: 0 0 2.25rem 0;
`

class Theme extends Component {
  componentDidMount() {
    this.props.createThemeState()
  }

  componentWillUnmount() {
    this.props.destroyThemeState()
  }

  render() {
    if (this.props.loading) {
      return null
    }

    return (
      <Main>
        <EditorCanvas isRightSidebarOpen>
          <Page>
            {this.props.pageComponents.map(pageComponent => (
              <PageComponent key={pageComponent._cid}>
                <Viewport
                  containerId="editor-canvas"
                  device={this.props.device}
                >
                  <ComponentRenderer
                    theme={this.props.theme}
                    pageComponent={pageComponent}
                  />
                </Viewport>
              </PageComponent>
            ))}
          </Page>
        </EditorCanvas>

        <ThemeEditor />

        <Prompt
          when={this.props.hasUnsavedChanges}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      </Main>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createThemeState: () => dispatch(createThemeState()),
    destroyThemeState: () => dispatch(destroyThemeState())
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.project.loading,
    project: state.project.project,
    device: state.project.device,
    theme: state.project.theme,
    hasUnsavedChanges: state.project.hasUnsavedChanges,
    pageComponents: state.project.pageComponents
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Theme)



// WEBPACK FOOTER //
// ./src/components/Theme/index.js